
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.794 0c-1.98.069-3.447.619-4.4 1.719-1.027 1.306-1.252 3.308-.665 5.715-.22.275-.435.739-.435 1.289.146 1.1.66 1.804 1.1 2.148.293 1.031 1.017 1.908 1.604 2.32v.903l.298.129c.733.412 2.053.902 2.567.902.513 0 1.672-.473 2.406-.816l.527-.28v-.752c.66-.48 1.315-1.375 1.535-2.406.44-.344 1.032-1.044 1.032-1.869 0-.55-.147-1.027-.367-1.44.293-.962.949-3.635-.298-5.285-.367-.48-.963-.98-2.063-1.117C13.05.473 11.967 0 10.794 0zM7.562 15.34c-.513.344-1.32.601-2.2.945C3.09 17.11.22 18.081 0 21.312c0 .207.083.336.23.473.072.138.215.215.435.215h8.8v-.688c0-1.993 1.168-3.78 1.168-3.78l-.573-1.16c-.953-.276-2.14-.83-2.36-.968l-.138-.064zm6.807 0l-.275.129c-.22.137-1.339.627-2.292.902l-.573 1.16s1.238 1.788 1.238 3.782V22h8.8c.22 0 .38-.077.527-.215a.68.68 0 00.206-.473c-.293-3.23-3.158-4.27-5.431-5.027-.88-.275-1.687-.601-2.2-.945z","fill":"#282828"}})])
          )
        }
      }
    